import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import ChartDataLabels from "chartjs-plugin-datalabels";
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const ParticipationGroupchart = (props) => {
  const labels = [];
  const sections = {};

  props.Data610?.forEach((item) => {
    if (item.grade === props.Grade) {
      sections[item.subject] = [];
    }
  });
  props.Labels?.forEach((sec, index) => {
    labels.push(`Section ${sec.toUpperCase()}`);
    props.Data610?.forEach((item) => {
      if (item.grade === props.Grade && item[sec] > 0) {
        sections[item.subject].push(item[sec]);
        if (!labels.includes(`Section ${sec.toUpperCase()}`)) {
        }
      }
    });
  });

  const GetPColor = (e) => {
    switch (e) {
      case "English":
        return "#0B6EE3";
      case "Mathematics":
        return "#3DA663";
      case "Biology":
        return "#9951BB";
      case "BioTechnology":
        return "#EE649E";
         case "Hindi":
        return "#f96393";
         case "Telugu":
        return "#AD46FF";
      default:
        return "#F59E3C";
    }
  };
  const datasets = Object.keys(sections)?.map((section) => ({
    label: section,
    data: sections[section],
    backgroundColor: GetPColor(section),
  }));
  // let filteredData;
  //   const datasets = Object.keys(sections)?.map(section => {
  //      filteredData = sections[section].map((value) => value !== 0 && value); // Replace 0 with null to hide them
  //     return {
  //       // label: filteredData.map((value)=>value !== null && section ),
  //       label: section,
  //       data: filteredData, // Use the filtered data
  //       backgroundColor: GetPColor(section),
  //     };
  //   });
  const data = {
    labels: labels,
    // labels: labels,
    datasets: datasets,
  };
  const options = {
    aspectRatio: 3,
    responsive: true,
    plugins: {
      legend: { position: "bottom", labels: { usePointStyle: true } },
      layout: { padding: { right: 100 } },
      tooltip: {
        callbacks: {
          label: function (context) {
            let label = context.dataset.label || "";
            if (label) {
              label += ": ";
            }
            if (context.parsed.y !== null) {
              label += context.parsed.y + "%";
            }
            return label;
          },
        },
      },
      datalabels: {
        anchor: "end",
        align: "end",
        offset: -5,
        formatter: (value) => {
          return value;
        },
        font: {
          size: 12,
          weight: "bold",
        },
      },
    },
    scales: {
      x: { title: { display: true, text: "Assessment Date" } },
      y: { max: 100, title: { display: true, text: "Score %" } },
    },
  };
  return <Bar options={options} data={data} plugins={[ChartDataLabels]}  ref={props.Ref}/>;
};
export default ParticipationGroupchart;
